module.exports = __webpack_public_path__ + "img/22.b1cbdc8e.svg";